import './sib-arena-sectors.scss';

import { WpArenaSectors } from '../../components';
import Component, { mixins } from 'vue-class-component';
import { ArenaSector, SibIdentity, SibSymbols, IdentityChangedEventArgs, ICartService, CartSymbols } from 'web-platform-core-ui';

@Component({
    template: require("./sib-arena-sectors.html")
})
export default class SibArenaSectors extends WpArenaSectors {
    AuthModal: boolean = false;
    Context?: SibIdentity;
    CurrentSector?: ArenaSector;

    async SectorSelected(sector: ArenaSector) {
        this.Context = this.GlobalService.Get<SibIdentity>(SibSymbols.SibContext);

        if (this.Context.IsAuthentificated) {

            if (this.Context._sibUser != null) {
                let cartService = this.GlobalService.Get<ICartService>(CartSymbols.CartService);

                let cart = await cartService.GetCurrentOrCreateCartAsync();
                //cart.CartMaxItems = 1;
            }

            this.$emit("SectorSelected", { Sector: sector, ArenaText: this.SectorsList.ArenaText, ArenaPosition: this.SectorsList.ArenaPosition });
            return;
        }

        this.CurrentSector = sector;
        this.AuthModal = true;
    }

    async PolygonSelected(sector: ArenaSector) {
        this.Context = this.GlobalService.Get<SibIdentity>(SibSymbols.SibContext);

        if (this.Context.IsAuthentificated) {
            if (this.Context._sibUser != null) {
                let cartService = this.GlobalService.Get<ICartService>(CartSymbols.CartService);
                let cart = await cartService.GetCurrentOrCreateCartAsync();

                //cart.CartMaxItems = 1;
            }

            this.$emit("SectorSelected", { Sector: sector, ArenaText: this.SectorsList.ArenaText, ArenaPosition: this.SectorsList.ArenaPosition });
            return;
        }

        this.CurrentSector = sector;
        this.AuthModal = true;
    }

    StandartAuth() {
        this.AuthModal = false;
        this.Context?.SignIn();
    }

    SibAuth() {
        this.AuthModal = false;
        this.Context?.SigInSib();
        this.Context?.IdentityChanged.Subscribe(this.IdentityChanged);
    }

    async IdentityChanged(e: any, args: IdentityChangedEventArgs) {
        this.Context = this.GlobalService.Get<SibIdentity>(SibSymbols.SibContext);
        let cartService = this.GlobalService.Get<ICartService>(CartSymbols.CartService);
        let cart = await cartService.GetCurrentOrCreateCartAsync();

        cart.Clear();
        cart.OrderId = undefined;
        //if (this.Context._sibUser != null) {
        //    cart.CartMaxItems = 1;
        //}
    }
}